import * as React from 'react';
import { Drawer as DrawerPrimitive } from 'vaul';
import { cn } from '@/utils/tailwind.util';
const Drawer = ({
  shouldScaleBackground = true,
  dismissible = false,
  ...props
}: React.ComponentProps<typeof DrawerPrimitive.Root>) => <DrawerPrimitive.Root dismissible={dismissible} shouldScaleBackground={shouldScaleBackground} {...props} data-sentry-element="unknown" data-sentry-component="Drawer" data-sentry-source-file="drawer.tsx" />;
Drawer.displayName = 'Drawer';
const DrawerTrigger = DrawerPrimitive.Trigger;
const DrawerPortal = DrawerPrimitive.Portal;
const DrawerClose = DrawerPrimitive.Close;
const DrawerOverlay = React.forwardRef<React.ElementRef<typeof DrawerPrimitive.Overlay>, React.ComponentPropsWithoutRef<typeof DrawerPrimitive.Overlay>>(({
  className,
  ...props
}, ref) => <DrawerPrimitive.Overlay ref={ref} className={cn('fixed inset-0 z-modal bg-[rgba(28,27,31,0.24)] transition-all duration-200', 'data-[state=open]:animate-in data-[state=open]:fade-in-0', 'data-[state=closed]:animate-out data-[state=closed]:fade-out-0', className)} {...props} />);
DrawerOverlay.displayName = DrawerPrimitive.Overlay.displayName;
const DrawerContent = React.forwardRef<React.ElementRef<typeof DrawerPrimitive.Content>, React.ComponentPropsWithoutRef<typeof DrawerPrimitive.Content> & {
  hasDrawerHandle: boolean;
  hasDim: boolean;
  CustomDim?: React.ForwardRefExoticComponent<React.RefAttributes<HTMLDivElement> & React.HTMLAttributes<HTMLDivElement>>;
  onDimClick?: () => void;
}>(({
  className,
  children,
  hasDrawerHandle,
  hasDim,
  CustomDim,
  onDimClick,
  ...props
}, ref) => <DrawerPortal>
      {hasDim && (CustomDim ? <CustomDim onClick={onDimClick} /> : <DrawerOverlay onClick={onDimClick} />)}
      <DrawerPrimitive.Content ref={ref} className={cn(
  // zus Drawer(packages/zus/src/components/drawer/Drawer.tsx)와 동일한 모서리 반경.
  // rounded-t-lg 는 ZUS 토큰상 24px 이라 zus 기본 10px 과 형태가 어긋났다.
  // overflow-hidden 은 둥근 모서리 밖으로 내용이 새는 걸 막는 용도라 유지한다.
  'shadow-xl fixed bottom-0 z-modal mt-24 flex h-auto flex-col overflow-hidden rounded-t-[10px] border bg-white', hasDim && 'shadow-2xl', className)} {...props}>
        {hasDrawerHandle && <div className="pb-4xs pt-sm">
            <div className="mx-auto h-[4px] w-[64px] rounded-full bg-gray-300" />
          </div>}
        {children}
      </DrawerPrimitive.Content>
    </DrawerPortal>);
DrawerContent.displayName = 'DrawerContent';
const DrawerHeader = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => <div className={className} {...props} data-sentry-component="DrawerHeader" data-sentry-source-file="drawer.tsx" />;
DrawerHeader.displayName = 'DrawerHeader';
const DrawerFooter = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => <div className={cn('mt-auto flex flex-col gap-2 p-4', className)} {...props} data-sentry-component="DrawerFooter" data-sentry-source-file="drawer.tsx" />;
DrawerFooter.displayName = 'DrawerFooter';
const DrawerTitle = React.forwardRef<React.ElementRef<typeof DrawerPrimitive.Title>, React.ComponentPropsWithoutRef<typeof DrawerPrimitive.Title>>(({
  className,
  ...props
}, ref) => <DrawerPrimitive.Title ref={ref} className={className} {...props} />);
DrawerTitle.displayName = DrawerPrimitive.Title.displayName;
const DrawerDescription = React.forwardRef<React.ElementRef<typeof DrawerPrimitive.Description>, React.ComponentPropsWithoutRef<typeof DrawerPrimitive.Description>>(({
  className,
  ...props
}, ref) => <DrawerPrimitive.Description ref={ref} className={cn('text-sm text-slate-500 dark:text-slate-400', className)} {...props} />);
DrawerDescription.displayName = DrawerPrimitive.Description.displayName;
export { Drawer, DrawerPortal, DrawerOverlay, DrawerTrigger, DrawerClose, DrawerContent, DrawerHeader, DrawerFooter, DrawerTitle, DrawerDescription };